export interface LuSwitchConfigOptions {
	disabled?: boolean;
	truthyText?: string;
	falsyText?: string;
	tooltipMessage?: string;
}

export const KEY_F1 = 'F1';
export const KEY_ENTER = 'Enter';
export const KEY_SPACE = ' ';
